export interface ISearchedMemberModel {
  id: string;
  type: string;
  name: string;
  details: {
    cardNo: string;
    pointsBalance: string;
    verifyPin: string;
  };
}
